import {SuperObjectRelation} from './super-object-relation';

export class SuperobjectFolderItem extends SuperObjectRelation {
  object_type = 'SuperobjectFolderItem';
  folder_id: string;
  folder_id_value: string;
  folder_type_id: string;
  folder_type_id_value: string;
}
